import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ActionStatus } from '../types';

type IconActionStatusProps = {
    status: ActionStatus;
};

export default function IconActionStatus({status}: IconActionStatusProps) {
    if (status === ActionStatus.ACTING) {
        return (
            <div className="icon-action-status status-ACTING">
                <FontAwesomeIcon icon="circle-notch" size="sm" spin />
            </div>
        )
    }
    if (status === ActionStatus.TO_ACT) {
        return (
            <div className="icon-action-status status-TO_ACT">
                <FontAwesomeIcon icon="stopwatch" size="sm"/>
            </div>
        )
    }
    if (status === ActionStatus.ACTED) {
        return (
            <div className="icon-action-status status-ACTED">
                <FontAwesomeIcon icon="check-square" size="sm"/>
            </div>
        )
    }
    if (status === ActionStatus.ERROR) {
        return (
            <div className="icon-action-status status-ERROR">
                <FontAwesomeIcon icon="minus-square" size="sm"/>
            </div>
        )
    }
    return (
        <div className="icon-action-status status-ERROR">
            <FontAwesomeIcon icon="minus-square" size="sm"/>
        </div>
    )
}
